import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addAutoServer from "./components/addAutoServer.vue";
import { autServerConfigList, deleteAutoServerConfig } from "@/api/gmtool/packageCode";
import richTextDetails from "./components/richTextDetails.vue";
import { gmTool } from "@/mixins/index";
import { times } from "lodash";
export default {
  name: "automaticServer",
  mixins: [gmTool],
  components: {
    addAutoServer: addAutoServer,
    richTextDetails: richTextDetails
  },
  data: function data() {
    return {
      tableData: []
    };
  },
  activated: function activated() {
    this.getList();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.reqLoading = true;
      autServerConfigList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        game_id: this.rawData.game_id
      })).then(function (res) {
        if (res.code == 200) {
          res.data.forEach(function (item) {
            if (item.not_open_hour_duration) {
              item.not_open_hour_duration = JSON.parse(item.not_open_hour_duration);
            } else {
              item.not_open_hour_duration = [];
            }
          });
          _this.tableData = res.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deleteAutoServerConfig({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.getList(_this2.paramsData.page);

                    _this2.$message({
                      type: "success",
                      message: _this2.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};